export default "__VITE_ASSET__DEuBLh9v__"